module.exports = __webpack_public_path__ + "static/media/DeleteIcon.260947e3.svg";